{
  "module_key": "fulfilment_costs",
  "area_key": "margin_engine",
  "display_name": "Precision Fulfilment",
  "kind": "native",
  "api_base": "https://os.ketosource.co/fulfilment_costs/v1",
  "permission_scopes": [
    "area:margin_engine",
    "module:fulfilment_costs",
    "tab:fulfilment_costs/rates",
    "tab:fulfilment_costs/billing"
  ],
  "tabs": [
    { "tab_key": "fulfilment_index", "display_name": "Fulfilment Index", "tab_order": 1, "permission_scope": "area:margin_engine" },
    { "tab_key": "history", "display_name": "Cost History", "tab_order": 2, "permission_scope": "area:margin_engine" },
    { "tab_key": "monitor", "display_name": "Freshness Monitor", "tab_order": 3, "permission_scope": "area:margin_engine" },
    { "tab_key": "rates", "display_name": "Rates and Fees", "tab_order": 4, "permission_scope": "tab:fulfilment_costs/rates" },
    { "tab_key": "files", "display_name": "Billing files", "tab_order": 5, "permission_scope": "tab:fulfilment_costs/billing" },
    { "tab_key": "tpl_history", "display_name": "3PL History", "tab_order": 6, "permission_scope": "area:margin_engine" }
  ],
  "owner_email": "bojan@ketosource.co",
  "help_url": "mailto:bojan@ketosource.co"
}
